import React, { useEffect, useState } from 'react';
import { XIcon, MapPinIcon, SearchIcon, PackageIcon, StoreIcon, NavigationIcon, PencilIcon, TrashIcon, ChevronRightIcon, HomeIcon, BriefcaseIcon, MapIcon, ArrowLeftIcon } from 'lucide-react';
interface LocationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectLocation: (location: any) => void;
  initialAddress?: {
    city?: string;
    district?: string;
    street?: string;
    additionalDetails?: string;
    nationalAddressId?: string;
  };
}
type Step = 'main' | 'currentLocation' | 'manual' | 'national';
export function LocationModal({
  isOpen,
  onClose,
  onSelectLocation,
  initialAddress
}: LocationModalProps) {
  const [deliveryType, setDeliveryType] = useState<'delivery' | 'pickup'>('delivery');
  const [step, setStep] = useState<Step>('main');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedAddress, setSelectedAddress] = useState<any>(null);
  const [selectedPickupBranch, setSelectedPickupBranch] = useState<any>(null);
  const [pickupCity, setPickupCity] = useState('');
  const [pickupDistrict, setPickupDistrict] = useState('');
  const [showNearest, setShowNearest] = useState(false);
  const [gpsAddress, setGpsAddress] = useState('2214 Prince Mohammed Bin Salman Rd, Al Yasmin, Riyadh, Saudi Arabia');
  const detectedLocation = {
    lat: 24.7136,
    lng: 46.6753
  };
  const [manualCity, setManualCity] = useState('');
  const [manualDistrict, setManualDistrict] = useState('');
  const [manualDetails, setManualDetails] = useState('');
  const [nationalAddressId, setNationalAddressId] = useState('');
  const [nationalAddressDetails, setNationalAddressDetails] = useState<any>(null);
  const [savedAddresses, setSavedAddresses] = useState([{
    id: 1,
    name: 'Home',
    address: '2214 Prince Mohammed Bin Salman Rd, Al Yasmin, Riyadh, Saudi Arabia',
    type: 'home',
    icon: HomeIcon
  }, {
    id: 2,
    name: 'Work',
    address: '1234 King Fahd Rd, Al Olaya, Riyadh, Saudi Arabia',
    type: 'work',
    icon: BriefcaseIcon
  }]);
  const allPharmacyBranches = [{
    id: 1,
    name: 'Innova Pharmacy - Riyadh Park',
    address: 'Riyadh Park Mall, Al Malaz, Riyadh',
    city: 'Riyadh',
    district: 'Al Malaz',
    distance: 2.5,
    hours: 'Open until 11:00 PM',
    status: 'open'
  }, {
    id: 2,
    name: 'Innova Pharmacy - Kingdom Centre',
    address: 'Kingdom Centre, Al Olaya, Riyadh',
    city: 'Riyadh',
    district: 'Al Olaya',
    distance: 3.2,
    hours: 'Open 24 hours',
    status: 'open'
  }, {
    id: 3,
    name: 'Innova Pharmacy - Al Nakheel',
    address: 'Al Nakheel District, Riyadh',
    city: 'Riyadh',
    district: 'Al Nakheel',
    distance: 4.1,
    hours: 'Open until 10:00 PM',
    status: 'open'
  }, {
    id: 4,
    name: 'Innova Pharmacy - Al Yasmin',
    address: 'Prince Mohammed Bin Salman Rd, Al Yasmin, Riyadh',
    city: 'Riyadh',
    district: 'Al Yasmin',
    distance: 1.8,
    hours: 'Open until 12:00 AM',
    status: 'open'
  }, {
    id: 5,
    name: 'Innova Pharmacy - Red Sea Mall',
    address: 'Red Sea Mall, Al Rawdah, Jeddah',
    city: 'Jeddah',
    district: 'Al Rawdah',
    distance: 3.5,
    hours: 'Open until 11:00 PM',
    status: 'open'
  }, {
    id: 6,
    name: 'Innova Pharmacy - Corniche',
    address: 'Corniche Road, Al Salama, Jeddah',
    city: 'Jeddah',
    district: 'Al Salama',
    distance: 5.2,
    hours: 'Open 24 hours',
    status: 'open'
  }, {
    id: 7,
    name: 'Innova Pharmacy - Al Zahra',
    address: 'Al Zahra District, Jeddah',
    city: 'Jeddah',
    district: 'Al Zahra',
    distance: 2.8,
    hours: 'Open until 10:00 PM',
    status: 'open'
  }, {
    id: 8,
    name: 'Innova Pharmacy - Al Nahda',
    address: 'Al Nahda District, Jeddah',
    city: 'Jeddah',
    district: 'Al Nahda',
    distance: 4.3,
    hours: 'Open until 11:30 PM',
    status: 'open'
  }, {
    id: 9,
    name: 'Innova Pharmacy - Al Aziziyah',
    address: 'Al Aziziyah District, Makkah',
    city: 'Makkah',
    district: 'Al Aziziyah',
    distance: 2.1,
    hours: 'Open 24 hours',
    status: 'open'
  }, {
    id: 10,
    name: 'Innova Pharmacy - Al Shawqiyah',
    address: 'Al Shawqiyah District, Makkah',
    city: 'Makkah',
    district: 'Al Shawqiyah',
    distance: 3.7,
    hours: 'Open until 11:00 PM',
    status: 'open'
  }, {
    id: 11,
    name: 'Innova Pharmacy - Al Khalidiyyah',
    address: 'Al Khalidiyyah District, Madinah',
    city: 'Madinah',
    district: 'Al Khalidiyyah',
    distance: 1.9,
    hours: 'Open 24 hours',
    status: 'open'
  }, {
    id: 12,
    name: 'Innova Pharmacy - Quba',
    address: 'Quba District, Madinah',
    city: 'Madinah',
    district: 'Quba',
    distance: 4.5,
    hours: 'Open until 10:00 PM',
    status: 'open'
  }, {
    id: 13,
    name: 'Innova Pharmacy - Al Faisaliyah',
    address: 'Al Faisaliyah District, Dammam',
    city: 'Dammam',
    district: 'Al Faisaliyah',
    distance: 2.3,
    hours: 'Open until 11:00 PM',
    status: 'open'
  }, {
    id: 14,
    name: 'Innova Pharmacy - Al Shati',
    address: 'Al Shati District, Dammam',
    city: 'Dammam',
    district: 'Al Shati',
    distance: 3.8,
    hours: 'Open 24 hours',
    status: 'open'
  }, {
    id: 15,
    name: 'Innova Pharmacy - Al Corniche',
    address: 'Al Corniche District, Khobar',
    city: 'Khobar',
    district: 'Al Corniche',
    distance: 1.5,
    hours: 'Open until 12:00 AM',
    status: 'open'
  }, {
    id: 16,
    name: 'Innova Pharmacy - Al Aqrabiyah',
    address: 'Al Aqrabiyah District, Khobar',
    city: 'Khobar',
    district: 'Al Aqrabiyah',
    distance: 3.1,
    hours: 'Open until 11:00 PM',
    status: 'open'
  }];
  const cities = [{
    id: 'riyadh',
    name: 'Riyadh'
  }, {
    id: 'jeddah',
    name: 'Jeddah'
  }, {
    id: 'makkah',
    name: 'Makkah'
  }, {
    id: 'madinah',
    name: 'Madinah'
  }, {
    id: 'dammam',
    name: 'Dammam'
  }, {
    id: 'khobar',
    name: 'Khobar'
  }];
  const districtsByCity = {
    riyadh: ['Al Olaya', 'Al Malaz', 'Al Nakheel', 'Al Yasmin'],
    jeddah: ['Al Rawdah', 'Al Salama', 'Al Zahra', 'Al Nahda'],
    makkah: ['Al Aziziyah', 'Al Shawqiyah', 'Al Hindawiyah', 'Jarwal'],
    madinah: ['Al Khalidiyyah', 'Al Uyun', 'Al Iskan', 'Quba'],
    dammam: ['Al Faisaliyah', 'Al Shati', 'Al Adamah', 'Al Noor'],
    khobar: ['Al Corniche', 'Al Aqrabiyah', 'Al Thuqbah', 'Al Hizam']
  };
  const getFilteredBranches = () => {
    let filtered = [...allPharmacyBranches];
    if (pickupCity) {
      const cityName = cities.find(c => c.id === pickupCity)?.name;
      filtered = filtered.filter(branch => branch.city === cityName);
    }
    if (pickupDistrict) {
      filtered = filtered.filter(branch => branch.district === pickupDistrict);
    }
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(branch => branch.name.toLowerCase().includes(query) || branch.address.toLowerCase().includes(query) || branch.city.toLowerCase().includes(query) || branch.district.toLowerCase().includes(query));
    }
    if (showNearest) {
      filtered.sort((a, b) => a.distance - b.distance);
    }
    return filtered;
  };
  const handleNavigateToStep = (newStep: Step) => {
    setStep(newStep);
  };
  const handleBackToMain = () => {
    setStep('main');
  };
  const handleSaveGPSLocation = () => {
    const newAddress = {
      id: Date.now(),
      name: 'Current Location',
      address: gpsAddress,
      type: 'current',
      icon: NavigationIcon
    };
    setSavedAddresses([...savedAddresses, newAddress]);
    setSelectedAddress(newAddress);
    setStep('main');
  };
  const handleSaveManualAddress = () => {
    if (!manualCity || !manualDistrict || !manualDetails) {
      alert('Please fill in all fields');
      return;
    }
    const cityName = cities.find(c => c.id === manualCity)?.name || manualCity;
    const fullAddress = `${manualDetails}, ${manualDistrict}, ${cityName}, Saudi Arabia`;
    const newAddress = {
      id: Date.now(),
      name: 'Custom Address',
      address: fullAddress,
      type: 'custom',
      icon: MapPinIcon
    };
    setSavedAddresses([...savedAddresses, newAddress]);
    setSelectedAddress(newAddress);
    setManualCity('');
    setManualDistrict('');
    setManualDetails('');
    setStep('main');
  };
  const handleGetNationalAddress = () => {
    if (!nationalAddressId) {
      alert('Please enter a National Address ID');
      return;
    }
    setNationalAddressDetails({
      city: 'Riyadh',
      district: 'Al Yasmin',
      street: 'Prince Mohammed Bin Salman Rd',
      buildingNo: '2214',
      postalCode: '13325',
      additionalInfo: 'Villa 4'
    });
  };
  const handleSaveNationalAddress = () => {
    if (!nationalAddressDetails) return;
    const fullAddress = `${nationalAddressDetails.buildingNo} ${nationalAddressDetails.street}, ${nationalAddressDetails.district}, ${nationalAddressDetails.city}, Saudi Arabia`;
    const newAddress = {
      id: Date.now(),
      name: 'National Address',
      address: fullAddress,
      type: 'national',
      icon: MapIcon
    };
    setSavedAddresses([...savedAddresses, newAddress]);
    setSelectedAddress(newAddress);
    setNationalAddressId('');
    setNationalAddressDetails(null);
    setStep('main');
  };
  const handleRemoveAddress = (id: number) => {
    setSavedAddresses(savedAddresses.filter(addr => addr.id !== id));
    if (selectedAddress?.id === id) {
      setSelectedAddress(null);
    }
  };
  const handleEditAddress = (address: any) => {
    const newName = prompt('Enter new name for this address:', address.name);
    if (newName) {
      setSavedAddresses(savedAddresses.map(addr => addr.id === address.id ? {
        ...addr,
        name: newName
      } : addr));
    }
  };
  const handleConfirmAddress = () => {
    if (deliveryType === 'delivery' && selectedAddress) {
      onSelectLocation({
        ...selectedAddress,
        type: 'delivery'
      });
      onClose();
    } else if (deliveryType === 'pickup' && selectedPickupBranch) {
      onSelectLocation({
        ...selectedPickupBranch,
        type: 'pickup'
      });
      onClose();
    } else {
      alert('Please select an address or pickup location');
    }
  };
  const handleClose = () => {
    setStep('main');
    onClose();
  };
  const ModalHeader = ({
    title,
    showBack = false
  }: {
    title: string;
    showBack?: boolean;
  }) => <div className="bg-[#0066CC] p-4 text-white flex items-center justify-between flex-shrink-0" data-id="element-3993" data-mp="2esv72r1vryf">
      <div className="flex items-center flex-1" data-id="element-3994" data-mp="796omzm5jp0g">
        {showBack && <button onClick={handleBackToMain} className="p-2 hover:bg-white/20 rounded-full transition-colors mr-3" data-id="element-3995" data-mp="3pn67tya46anf">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-3996" data-mp="m43a4eiz28vh" />
          </button>}
        <h3 className="text-xl font-bold" data-id="element-3997" data-mp="q67x4uex0795">{title}</h3>
      </div>
      <button onClick={handleClose} className="p-2 hover:bg-white/20 rounded-full transition-colors" data-id="element-3998" data-mp="q5f0im9o6y4q">
        <XIcon className="w-5 h-5" data-id="element-3999" data-mp="c8t29a5w779s" />
      </button>
    </div>;
  const renderContent = () => {
    switch (step) {
      case 'currentLocation':
        return <>
            <ModalHeader title="Confirm Your Location" showBack data-id="element-4000" data-mp="2wyqvjjida6fs" />
            <div className="relative bg-gray-200 h-64 flex-shrink-0 md:h-80" data-id="element-4001" data-mp="31wshcc76gjuy">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-4002" data-mp="2hu61x7vd68pg">
                <div className="text-center" data-id="element-4003" data-mp="2dsazu15lzram">
                  <MapPinIcon className="w-12 h-12 text-[#0066CC] mx-auto mb-2" data-id="element-4004" data-mp="2dskrdt6ay6if" />
                  <p className="text-sm text-gray-600 font-medium" data-id="element-4005" data-mp="290auft6rs66n">Map View</p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-4006" data-mp="242rhcwlt5zga">
                    Lat: {detectedLocation.lat}, Lng: {detectedLocation.lng}
                  </p>
                </div>
              </div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-full" data-id="element-4007" data-mp="1u3k223vijuqj">
                <MapPinIcon className="w-8 h-8 text-red-500 drop-shadow-lg" data-id="element-4008" data-mp="1q1or07ns62zk" />
              </div>
            </div>
            <div className="p-6 flex-1 overflow-y-auto" data-id="element-4009" data-mp="1l4f4azrs05ff">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4010" data-mp="3kghjvyxa4fnt">
                Detected Address
              </label>
              <textarea value={gpsAddress} onChange={e => setGpsAddress(e.target.value)} className="w-full border border-gray-300 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent resize-none" rows={3} data-id="element-4011" data-mp="3fh4w9byl34k6" />
              <p className="text-xs text-gray-500 mt-2" data-id="element-4012" data-mp="m4lx9e3ujes">
                You can edit the address if needed
              </p>
            </div>
            <div className="p-6 border-t border-gray-200 flex gap-3 flex-shrink-0" data-id="element-4013" data-mp="342beokuzew8s">
              <button onClick={handleBackToMain} className="flex-1 border-2 border-gray-300 text-gray-700 font-medium py-3 px-4 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-4014" data-mp="3914tqhpx2vb2">
                Back
              </button>
              <button onClick={handleSaveGPSLocation} className="flex-1 bg-[#0066CC] hover:bg-[#0052a3] text-white font-medium py-3 px-4 rounded-lg transition-colors" data-id="element-4015" data-mp="3i35ptb9ezbb5">
                Save Location
              </button>
            </div>
          </>;
      case 'manual':
        return <>
            <ModalHeader title="Add Address Manually" showBack data-id="element-4016" data-mp="qw52pyn1fyfl" />
            <div className="p-6 flex-1 overflow-y-auto" data-id="element-4017" data-mp="qxptrea58z8p">
              <div className="space-y-4" data-id="element-4018" data-mp="15tdweyztdeah">
                <div data-id="element-4019" data-mp="10tj6axnv4sqh">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4020" data-mp="10szy48o0lipn">
                    City *
                  </label>
                  <select value={manualCity} onChange={e => {
                  setManualCity(e.target.value);
                  setManualDistrict('');
                }} className="w-full border border-gray-300 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent" data-id="element-4021" data-mp="1erpvlpeqxkej">
                    <option value="" data-id="element-4022" data-mp="1xkbr28lqr8yl">Select City</option>
                    {cities.map(city => <option key={city.id} value={city.id} data-id="element-4023" data-mp="1tk1jwsm7qci5">
                        {city.name}
                      </option>)}
                  </select>
                </div>
                <div data-id="element-4024" data-mp="2h4sopm78e4hm">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4025" data-mp="2h37s7r1cwbh4">
                    District / Neighborhood *
                  </label>
                  <select value={manualDistrict} onChange={e => setManualDistrict(e.target.value)} disabled={!manualCity} className="w-full border border-gray-300 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed" data-id="element-4026" data-mp="283kqt58mn5o2">
                    <option value="" data-id="element-4027" data-mp="1ohfz135rxgk3">Select District</option>
                    {manualCity && districtsByCity[manualCity]?.map(district => <option key={district} value={district} data-id="element-4028" data-mp="1fghy4tqmtp5q">
                          {district}
                        </option>)}
                  </select>
                </div>
                <div data-id="element-4029" data-mp="3cdmi81nmn6hj">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4030" data-mp="3cd4g4oea9y1p">
                    Street / Building / Additional Details *
                  </label>
                  <textarea value={manualDetails} onChange={e => setManualDetails(e.target.value)} placeholder="Street name, building number, floor, apartment..." className="w-full border border-gray-300 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent resize-none" rows={4} data-id="element-4031" data-mp="33esgxxzcprxn" />
                </div>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex-shrink-0" data-id="element-4032" data-mp="2fpg66todlbt8">
              <button onClick={handleSaveManualAddress} className="w-full bg-[#0066CC] hover:bg-[#0052a3] text-white font-medium py-3 px-4 rounded-lg transition-colors" data-id="element-4033" data-mp="2apljl2bmv8dz">
                Save Location
              </button>
            </div>
          </>;
      case 'national':
        return <>
            <ModalHeader title="Use National Address" showBack data-id="element-4034" data-mp="2ahhtivqkvkzn" />
            <div className="p-6 flex-1 overflow-y-auto" data-id="element-4035" data-mp="2fbcjggws0w76">
              <div className="space-y-4" data-id="element-4036" data-mp="2jbwg7jdftxss">
                <div data-id="element-4037" data-mp="2jb37wdytz08j">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4038" data-mp="2jbmu46vikasd">
                    National Address ID
                  </label>
                  <input type="text" value={nationalAddressId} onChange={e => setNationalAddressId(e.target.value)} placeholder="1234-5678-9101" className="w-full border border-gray-300 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent" data-id="element-4039" data-mp="2t9j3at4w4vnu" />
                  <p className="text-xs text-gray-500 mt-2" data-id="element-4040" data-mp="35rwhl0tag5xf">
                    Enter your Saudi National Address ID
                  </p>
                </div>
                <button onClick={handleGetNationalAddress} className="w-full py-3 px-4 border-2 border-[#0066CC] text-[#0066CC] font-medium rounded-lg hover:bg-blue-50 transition-colors" data-id="element-4041" data-mp="30rqw62dm3fns">
                  Get Details
                </button>
                {nationalAddressDetails && <div className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-4042" data-mp="2hvr46rkmwc47">
                    <h4 className="font-semibold text-gray-900 mb-3" data-id="element-4043" data-mp="2vv0amzj1fruz">
                      Address Details
                    </h4>
                    <div className="space-y-2 text-sm" data-id="element-4044" data-mp="2rrbzy7z40g5i">
                      <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-4045" data-mp="b3qbdppqi3i5">
                        <span className="text-gray-600" data-id="element-4046" data-mp="72y06qxaxoj8">City:</span>
                        <span className="font-medium text-gray-900" data-id="element-4047" data-mp="74qy9htun0fm">
                          {nationalAddressDetails.city}
                        </span>
                      </div>
                      <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-4048" data-mp="jmuzf2iavy0x">
                        <span className="text-gray-600" data-id="element-4049" data-mp="4pawe14yscxe">District:</span>
                        <span className="font-medium text-gray-900" data-id="element-4050" data-mp="9maunpvkobdy">
                          {nationalAddressDetails.district}
                        </span>
                      </div>
                      <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-4051" data-mp="12cb1vvdjq0jz">
                        <span className="text-gray-600" data-id="element-4052" data-mp="nn53uaqg2gdo">Street:</span>
                        <span className="font-medium text-gray-900" data-id="element-4053" data-mp="nkso8485si3s">
                          {nationalAddressDetails.street}
                        </span>
                      </div>
                      <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-4054" data-mp="1ga80syfh2j1t">
                        <span className="text-gray-600" data-id="element-4055" data-mp="1l3u43zzqxaky">Building No.:</span>
                        <span className="font-medium text-gray-900" data-id="element-4056" data-mp="3coerrmu33tmu">
                          {nationalAddressDetails.buildingNo}
                        </span>
                      </div>
                      <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-4057" data-mp="32yc1hueckts7">
                        <span className="text-gray-600" data-id="element-4058" data-mp="37w3r2hris3t8">Postal Code:</span>
                        <span className="font-medium text-gray-900" data-id="element-4059" data-mp="37uan5a8ajxox">
                          {nationalAddressDetails.postalCode}
                        </span>
                      </div>
                      <div className="flex justify-between py-2" data-id="element-4060" data-mp="2xwczanucg2wu">
                        <span className="text-gray-600" data-id="element-4061" data-mp="2jzzofxkbezrc">Additional Info:</span>
                        <span className="font-medium text-gray-900" data-id="element-4062" data-mp="2owznvpmnt49h">
                          {nationalAddressDetails.additionalInfo}
                        </span>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>
            {nationalAddressDetails && <div className="p-6 border-t border-gray-200 flex-shrink-0" data-id="element-4063" data-mp="27oq9nwcyzfyb">
                <button onClick={handleSaveNationalAddress} className="w-full bg-[#0066CC] hover:bg-[#0052a3] text-white font-medium py-3 px-4 rounded-lg transition-colors" data-id="element-4064" data-mp="22qorrera5mof">
                  Save Location
                </button>
              </div>}
          </>;
      default:
        return <>
            <ModalHeader title="Select Location" data-id="element-4065" data-mp="2lgn2k2mgptvr" />
            <div className="p-6 pb-0" data-id="element-4066" data-mp="2li7udkhe6ypx">
              <div className="flex bg-gray-100 p-1 rounded-xl" data-id="element-4067" data-mp="30de1ybw4z5ld">
                <button onClick={() => setDeliveryType('delivery')} className={`flex-1 py-2.5 px-4 rounded-lg font-bold text-sm transition-all flex items-center justify-center gap-2 ${deliveryType === 'delivery' ? 'bg-white text-[#0066CC] shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-4068" data-mp="30aruec98wq35">
                  <PackageIcon className="w-4 h-4" data-id="element-4069" data-mp="1qp780bklvkfs" />
                  Home Delivery
                </button>
                <button onClick={() => setDeliveryType('pickup')} className={`flex-1 py-2.5 px-4 rounded-lg font-bold text-sm transition-all flex items-center justify-center gap-2 ${deliveryType === 'pickup' ? 'bg-white text-[#0066CC] shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-4070" data-mp="1uqirs0gstbg2">
                  <StoreIcon className="w-4 h-4" data-id="element-4071" data-mp="29l71xrx58y20" />
                  Store Pickup
                </button>
              </div>
            </div>
            <div className="p-6 overflow-y-auto flex-1" data-id="element-4072" data-mp="2igd1wa9qglwm">
              {deliveryType === 'delivery' ? <>
                  <div className="space-y-3 mb-6" data-id="element-4073" data-mp="2ndwnxwcoa2z4">
                    <button onClick={() => handleNavigateToStep('currentLocation')} className="w-full flex items-center p-4 border border-gray-200 rounded-xl hover:border-[#0066CC] hover:bg-blue-50 transition-all group" data-id="element-4074" data-mp="2se193zoizlvo">
                      <div className="flex-shrink-0 w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center mr-4 group-hover:bg-blue-100 transition-colors" data-id="element-4075" data-mp="gqfm13z8z6kv">
                        <NavigationIcon className="w-5 h-5 text-[#0066CC]" data-id="element-4076" data-mp="brbaw7sriyrw" />
                      </div>
                      <div className="text-left flex-1" data-id="element-4077" data-mp="6u2v2dv376tt">
                        <div className="font-bold text-gray-900" data-id="element-4078" data-mp="14ep1zp9s5043">
                          Use My Current Location
                        </div>
                        <div className="text-xs text-gray-500 mt-0.5" data-id="element-4079" data-mp="ziqhwdvhi49h">
                          Enable location services
                        </div>
                      </div>
                      <ChevronRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#0066CC] transition-colors" data-id="element-4080" data-mp="pqazxgk6tfol" />
                    </button>
                    <button onClick={() => handleNavigateToStep('manual')} className="w-full flex items-center p-4 border border-gray-200 rounded-xl hover:border-[#0066CC] hover:bg-blue-50 transition-all group" data-id="element-4081" data-mp="1ifro220ryaf0">
                      <div className="flex-shrink-0 w-10 h-10 bg-green-50 rounded-lg flex items-center justify-center mr-4 group-hover:bg-green-100 transition-colors" data-id="element-4082" data-mp="17u8jrc9lokxk">
                        <PencilIcon className="w-5 h-5 text-green-600" data-id="element-4083" data-mp="xyx9p79501w5" />
                      </div>
                      <div className="text-left flex-1" data-id="element-4084" data-mp="1lohu7ukxv77j">
                        <div className="font-bold text-gray-900" data-id="element-4085" data-mp="1qnm82yit5t47">
                          Enter Address Manually
                        </div>
                        <div className="text-xs text-gray-500 mt-0.5" data-id="element-4086" data-mp="1bxwqjsqerchr">
                          Fill in your address details
                        </div>
                      </div>
                      <ChevronRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#0066CC] transition-colors" data-id="element-4087" data-mp="24m2dmm4xpdkr" />
                    </button>
                    <button onClick={() => handleNavigateToStep('national')} className="w-full flex items-center p-4 border border-gray-200 rounded-xl hover:border-[#0066CC] hover:bg-blue-50 transition-all group" data-id="element-4088" data-mp="3u3zfh3p11c2n">
                      <div className="flex-shrink-0 w-10 h-10 bg-purple-50 rounded-lg flex items-center justify-center mr-4 group-hover:bg-purple-100 transition-colors" data-id="element-4089" data-mp="7qhj5vfhjjne">
                        <MapIcon className="w-5 h-5 text-purple-600" data-id="element-4090" data-mp="3b5n7vmdrka96" />
                      </div>
                      <div className="text-left flex-1" data-id="element-4091" data-mp="367ldi5aw0oie">
                        <div className="font-bold text-gray-900" data-id="element-4092" data-mp="3k5jnkyi6dys3">
                          Use National Address
                        </div>
                        <div className="text-xs text-gray-500 mt-0.5" data-id="element-4093" data-mp="3g2n3f3czlum1">
                          Enter your National Address ID
                        </div>
                      </div>
                      <ChevronRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#0066CC] transition-colors" data-id="element-4094" data-mp="vcxs30bhsqy3" />
                    </button>
                  </div>
                  {savedAddresses.length > 0 && <div data-id="element-4095" data-mp="3t5pok56t908s">
                      <h3 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-4096" data-mp="219ea3zr6ltg">
                        Saved Addresses
                      </h3>
                      <div className="space-y-3" data-id="element-4097" data-mp="61jjvfjmva7s">
                        {savedAddresses.map(address => {
                    const Icon = address.icon;
                    return <div key={address.id} className={`flex items-start p-3 border rounded-xl transition-all cursor-pointer ${selectedAddress?.id === address.id ? 'border-[#0066CC] bg-blue-50' : 'border-gray-200 hover:border-[#0066CC] hover:bg-blue-50'}`} onClick={() => setSelectedAddress(address)} data-id="element-4098" data-mp="3ahufgym58am0">
                              <div className="flex-shrink-0 w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center mr-3" data-id="element-4099" data-mp="2qqz5lw3zw8qk">
                                <Icon className="w-4 h-4 text-[#0066CC]" data-id="element-4100" data-mp="2eapq5ryn37ae" />
                              </div>
                              <div className="flex-1 min-w-0" data-id="element-4101" data-mp="2a8cvpzpcevsx">
                                <div className="font-bold text-sm text-gray-900" data-id="element-4102" data-mp="2aaz0jrkumx7g">
                                  {address.name}
                                </div>
                                <div className="text-xs text-gray-500 mt-0.5 line-clamp-1" data-id="element-4103" data-mp="20bgjbiwbppj3">
                                  {address.address}
                                </div>
                              </div>
                              <div className="flex-shrink-0 flex gap-1 ml-2" data-id="element-4104" data-mp="1ql5593ixdzyh">
                                <button onClick={e => {
                          e.stopPropagation();
                          handleEditAddress(address);
                        }} className="p-1.5 text-gray-400 hover:text-[#0066CC] hover:bg-blue-100 rounded-lg transition-colors" data-id="element-4105" data-mp="1mkl6jvipeoa8">
                                  <PencilIcon className="w-3.5 h-3.5" data-id="element-4106" data-mp="35g3qmd5gnaw1" />
                                </button>
                                <button onClick={e => {
                          e.stopPropagation();
                          handleRemoveAddress(address.id);
                        }} className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors" data-id="element-4107" data-mp="2rj87tszeq52s">
                                  <TrashIcon className="w-3.5 h-3.5" data-id="element-4108" data-mp="2cs7napldykqa" />
                                </button>
                              </div>
                            </div>;
                  })}
                      </div>
                    </div>}
                </> : <>
                  <div className="bg-gray-50 border border-gray-200 rounded-xl p-5 mb-6" data-id="element-4109" data-mp="1k69gkdkwons2">
                    <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-4110" data-mp="1f87pp6h8nk61">
                      Filter Branches
                    </h3>
                    <div className="space-y-4" data-id="element-4111" data-mp="1p4u8lpq0815f">
                      <div data-id="element-4112" data-mp="1p41b7fcxqnzy">
                        <label className="block text-xs font-medium text-gray-600 mb-2" data-id="element-4113" data-mp="1p6x8r2kvfanv">
                          City *
                        </label>
                        <select value={pickupCity} onChange={e => {
                      setPickupCity(e.target.value);
                      setPickupDistrict('');
                    }} className="w-full border border-gray-300 rounded-lg py-2.5 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent" data-id="element-4114" data-mp="1y6ahft167v7j">
                          <option value="" data-id="element-4115" data-mp="3j86nb79yhpxb">All Cities</option>
                          {cities.map(city => <option key={city.id} value={city.id} data-id="element-4116" data-mp="3e9dazi6eo4yq">
                              {city.name}
                            </option>)}
                        </select>
                      </div>
                      <div data-id="element-4117" data-mp="357ni07wvkxyu">
                        <label className="block text-xs font-medium text-gray-600 mb-2" data-id="element-4118" data-mp="35ai381npqmtb">
                          District / Neighborhood
                        </label>
                        <select value={pickupDistrict} onChange={e => setPickupDistrict(e.target.value)} disabled={!pickupCity} className="w-full border border-gray-300 rounded-lg py-2.5 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed" data-id="element-4119" data-mp="2vhu7la8gyow6">
                          <option value="" data-id="element-4120" data-mp="s1z9b2a0hen2">All Districts</option>
                          {pickupCity && districtsByCity[pickupCity]?.map(district => <option key={district} value={district} data-id="element-4121" data-mp="112dy4bm6pbvb">
                                {district}
                              </option>)}
                        </select>
                      </div>
                      <div className="flex items-center justify-between pt-2" data-id="element-4122" data-mp="9c93zl8mhagw">
                        <label className="text-sm font-medium text-gray-700" data-id="element-4123" data-mp="dcbac7pays2i">
                          Show Nearest Branches
                        </label>
                        <button onClick={() => setShowNearest(!showNearest)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${showNearest ? 'bg-[#0066CC]' : 'bg-gray-300'}`} data-id="element-4124" data-mp="i9t9x7hfjuxu">
                          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${showNearest ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-4125" data-mp="3qpwjjis3rtot" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="mb-6" data-id="element-4126" data-mp="12o7jv3iold7l">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4127" data-mp="12p8sz2g4zpmo">
                      Search Pharmacy
                    </label>
                    <div className="relative" data-id="element-4128" data-mp="9za3j5y15qhh">
                      <input type="text" placeholder="Search by area or pharmacy name" className="w-full border border-gray-300 rounded-lg py-3 pl-10 pr-4 focus:outline-none focus:ring-2 focus:ring-[#0066CC] focus:border-transparent" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-4129" data-mp="a0lebppw7yi3" />
                      <SearchIcon className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" data-id="element-4130" data-mp="22w5mk9m04cxu" />
                    </div>
                  </div>
                  <div data-id="element-4131" data-mp="26z2amfub9196">
                    <h3 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-4132" data-mp="1sxy6dszjdyww">
                      {showNearest ? 'Nearest Pharmacies' : 'Available Pharmacies'}{' '}
                      ({getFilteredBranches().length})
                    </h3>
                    <div className="space-y-3" data-id="element-4133" data-mp="2lozske1ncupx">
                      {getFilteredBranches().length > 0 ? getFilteredBranches().map(pharmacy => <button key={pharmacy.id} onClick={() => {
                    setSelectedPickupBranch(pharmacy);
                  }} className={`w-full flex items-start p-3 border rounded-xl transition-all text-left ${selectedPickupBranch?.id === pharmacy.id ? 'border-[#0066CC] bg-blue-50' : 'border-gray-200 hover:border-[#0066CC] hover:bg-blue-50'}`} data-id="element-4134" data-mp="2bwkalgqco651">
                            <div className="flex-shrink-0 w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center mr-3" data-id="element-4135" data-mp="1gnibj2cvkhaa">
                              <StoreIcon className="w-4 h-4 text-green-600" data-id="element-4136" data-mp="16qm1gs7bvn3m" />
                            </div>
                            <div className="flex-1" data-id="element-4137" data-mp="24e4foijrdhf0">
                              <div className="font-bold text-sm text-gray-900" data-id="element-4138" data-mp="24dkzb69rb133">
                                {pharmacy.name}
                              </div>
                              <div className="text-xs text-gray-500 mt-0.5 line-clamp-1" data-id="element-4139" data-mp="1unt5ie9hebzo">
                                {pharmacy.address}
                              </div>
                              <div className="flex items-center gap-3 mt-1.5" data-id="element-4140" data-mp="2n4lynvesgyn6">
                                <span className="text-[10px] text-[#0066CC] font-bold bg-blue-50 px-1.5 py-0.5 rounded" data-id="element-4141" data-mp="2n6oz79dkia65">
                                  {pharmacy.distance} km
                                </span>
                                <span className="text-[10px] text-green-600 font-bold bg-green-50 px-1.5 py-0.5 rounded" data-id="element-4142" data-mp="2uo4wh7soywft">
                                  {pharmacy.hours}
                                </span>
                              </div>
                            </div>
                          </button>) : <div className="text-center py-8 text-gray-500" data-id="element-4143" data-mp="38m3bmfeu6wwd">
                          <StoreIcon className="w-12 h-12 mx-auto mb-3 text-gray-400" data-id="element-4144" data-mp="3dlxy86rkx0bm" />
                          <p className="text-sm" data-id="element-4145" data-mp="3if0mbzdl7hkf">
                            No pharmacies found matching your filters
                          </p>
                          <p className="text-xs mt-1" data-id="element-4146" data-mp="3newt26do5n3o">
                            Try adjusting your search criteria
                          </p>
                        </div>}
                    </div>
                  </div>
                </>}
            </div>
            <div className="p-6 border-t border-gray-200 flex-shrink-0" data-id="element-4147" data-mp="1x6mc8s8txu0j">
              <button onClick={handleConfirmAddress} disabled={deliveryType === 'delivery' && !selectedAddress || deliveryType === 'pickup' && !selectedPickupBranch} className="w-full bg-[#0066CC] hover:bg-[#0052a3] text-white font-medium py-3 px-4 rounded-lg transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-4148" data-mp="1sbqmjyr2fiql">
                Confirm{' '}
                {deliveryType === 'delivery' ? 'Address' : 'Pickup Location'}
              </button>
            </div>
          </>;
    }
  };
  useEffect(() => {
    if (initialAddress) {
      setManualCity(initialAddress.city || '');
      setManualDistrict(initialAddress.district || '');
      setManualDetails(initialAddress.street || '');
      setNationalAddressId(initialAddress.nationalAddressId || '');
    }
  }, [initialAddress]);
  if (!isOpen) return null;
  return <>
      <div className="fixed inset-0 bg-black bg-opacity-45 z-[200] transition-opacity duration-300" onClick={handleClose} data-id="element-4149" data-mp="kignjbvz4tip"></div>
      <div className="fixed inset-0 z-[201] flex items-end md:items-center justify-center md:p-12" data-id="element-4150" data-mp="6ozckfhcsp4a">
        <div className="bg-white w-full md:w-[600px] lg:w-[650px] max-h-[90vh] md:max-h-[calc(100vh-96px)] overflow-hidden flex flex-col animate-slide-up md:animate-none md:rounded-xl shadow-2xl" style={{
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px'
      }} onClick={e => e.stopPropagation()} data-id="element-4151" data-mp="bnk1hir5nmdf">
          {renderContent()}
        </div>
      </div>
    </>;
}